import LeafRectangleLoader from "../../../../../../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import { useNoDataAvailableLabel } from "../../../../../../../../common/hooks/useNoDataAvailableLabel";
import "./TableTwoCols.scss";

export type Props<T> = {
  title?: string;
  formatTitle?: () => JSX.Element | string;
  list?: T[];
  col1: keyof T;
  col2: keyof T;
  formatCol1?: (data: T) => JSX.Element | number | string;
  formatCol2?: (data: T) => JSX.Element | number | string;
  isFetching: boolean;
  show?: boolean;
};

const TableTwoCols = <T extends object>(props: Props<T>) => {
  const noDataAvailableLabel = useNoDataAvailableLabel();
  const {
    list = [],
    title = "",
    formatTitle,
    formatCol1,
    col1,
    formatCol2,
    col2,
    isFetching = false,
    show = true,
  } = props;

  if (show === false || !list) {
    return <></>;
  }

  if (isFetching === true) {
    return (
      <div className="leaf-2-cols-table__loader">
        <LeafRectangleLoader isLoading={true} width={"100%"} height={"1.875rem"} numRows={4} />
      </div>
    );
  }

  return (
    <div className="leaf-2-cols-table">
      <div className="leaf-2-cols-table__container">
        <table className="leaf-2-cols-table__container__table">
          <thead>
            <tr>
              <td>
                {formatTitle ? (
                  formatTitle()
                ) : (
                  <p className="leaf-2-cols-table__container__table__default-title">{title}</p>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            {list.map((data, index) => {
              const col2Value = formatCol2 ? formatCol2(data) : (data[col2] as string | number);
              return (
                <tr
                  key={index}
                  className="leaf-2-cols-table__container__table_content leaf-2-cols-table__container__table__row"
                >
                  <td>{formatCol1 ? formatCol1(data) : (data[col1] as string | number)}</td>
                  <td aria-label={col2Value === "--" ? noDataAvailableLabel : undefined}>{col2Value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

TableTwoCols.displayName = "TableTwoCols";

export default TableTwoCols;
